// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconPeople = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      d="M7.5 12.75c-2.69 0-4.88-2.19-4.88-4.88S4.81 3 7.5 3s4.88 2.19 4.88 4.88-2.19 4.87-4.88 4.87zm0-8.25c-1.86 0-3.38 1.51-3.38 3.38 0 1.87 1.52 3.37 3.38 3.37 1.86 0 3.38-1.51 3.38-3.38C10.88 6 9.36 4.5 7.5 4.5zM15 20.25c0-4.14-3.36-7.5-7.5-7.5-4.14 0-7.5 3.36-7.5 7.5 0 .41.34.75.75.75s.75-.34.75-.75c0-3.31 2.69-6 6-6s6 2.69 6 6c0 .41.34.75.75.75s.75-.34.75-.75zm2.73-6.27c-2.27 0-4.12-1.85-4.12-4.12s1.85-4.12 4.12-4.12 4.12 1.85 4.12 4.12-1.85 4.12-4.12 4.12zm0-6.75c-1.45 0-2.62 1.18-2.62 2.62 0 1.44 1.18 2.62 2.62 2.62 1.44 0 2.62-1.18 2.62-2.62 0-1.44-1.18-2.62-2.62-2.62zM23.25 21c.42 0 .75-.34.75-.75 0-2.05-1.01-3.97-2.69-5.15a6.283 6.283 0 00-5.76-.74.74.74 0 00-.44.96c.14.39.58.59.96.44a4.78 4.78 0 014.38.56c1.28.89 2.04 2.36 2.05 3.92 0 .42.34.76.75.76z"
      fill="currentColor"
    />
  );
export default SvgIconPeople;
